import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import NavBar from 'components/Navbar';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import StudentTabs from 'components/StudentsTabs';
import SettingsCoachTabs from 'components/SettingsCoachTabs';
import SettingsTabs from 'components/SettingsTabs';
import CoachTabs from 'components/CoachTabs';
import styles from './DashBoardHeader.scss';// to import local scss fle

class DashBoardHeader extends Component {
  static propTypes = {
    usedFor: PropTypes.string.isRequired,
    tabListener: PropTypes.func.isRequired,
  };

  static defaultProps = {
    coachHeader: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      headerOnDashboard: true,
    };
  }
  render() {
    const { usedFor } = this.props;
    const settingsAthleteHeader = renderIf(usedFor === 'settingsAthlete');
    const settingsCoachHeader = renderIf(usedFor === 'settingsCoach');
    const renderCoachItems = renderIf(usedFor === 'coachDashboard');
    const renderAtheleteItems = renderIf(usedFor === 'athleteDashboard');
    return (
      <div className={usedFor === 'coachDashboard' || usedFor === 'settingsCoach' ? cn('row', styles.coachContainer) : cn('row', styles.container)}>
        <NavBar {...this.props} headerOnDashboard={this.state.headerOnDashboard} />
        <div className={cn('col s12', styles.currentUrl)}>
          {usedFor === ('settingsAthlete' || 'settingsCoach' || 'settingsParents') ? 'Settings' : 'My Dashboard' }
        </div>
        {settingsAthleteHeader(
          <SettingsTabs tabListener={this.props.tabListener} {...this.props} />,
          )}
        {renderCoachItems(
          <CoachTabs tabListener={this.props.tabListener} />,
          )}
        {renderAtheleteItems(
          <StudentTabs tabListener={this.props.tabListener} />,
          )}
        {settingsCoachHeader(
          <SettingsCoachTabs tabListener={this.props.tabListener} />,
          )}
      </div>
    );
  }
}

export default DashBoardHeader;



// WEBPACK FOOTER //
// ./src/components/DashBoardHeader/DashBoardHeader.js